import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { StreamDetailsComponent } from '../stream-details/stream-details.component';
import { StreamDetailsStore } from '../stream-details/stream-details.store';

@Component({
  imports: [StreamDetailsComponent],
  providers: [StreamDetailsStore],
  selector: 'app-twitch-stream-details',
  templateUrl: './twitch-stream-details.component.html',
})
export class TwitchStreamDetailsComponent extends DeliverableAnalyticsContentDirective {}
